import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {AppAlert, AppAlertType} from './app-alert';
import Swal from 'sweetalert2';
import {TranslateService} from "@ngx-translate/core";

export interface IConfirm {
  header: string ;
  message?: string ;
  acceptLabel?: string;
  html?:string,
  showCancelButton?:boolean;
  showCloseButton?:boolean;
  rejectLabel?: string;
  image?: string;
  icon?: string;
  accept?: () => void;
  reject?: () => void;
  close?: () => void;
  warningInfo?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AppAlertService {
  private readonly _eventSource = new Subject<AppAlert>();
  public eventSource = this._eventSource.asObservable();

  private acceptFunction: () => void;
  private rejectFunction: () => void;

  constructor(private readonly translate: TranslateService) {
  }

  sweetError(confirmParams: IConfirm) {
    confirmParams.icon = 'error';
    this.confirm(confirmParams);
  }

  sweetQuestion(confirmParams: IConfirm) {
    confirmParams.icon = 'question-circle';
    this.confirm(confirmParams);
  }

  sweetSuccess(confirmParams: IConfirm) {
    confirmParams.icon = 'success';
    this.confirm(confirmParams);
  }

  sweetInfo(confirmParams: IConfirm) {
    confirmParams.icon = 'info';
    this.confirm(confirmParams);
  }

  sweetWarning(confirmParams: IConfirm) {
    confirmParams.icon = 'warning';
    this.confirm(confirmParams);
  }

  sweetConfirm(confirmParams: IConfirm) {
    this.confirm(confirmParams);
  }

  sweetMessage(confirmParams: IConfirm) {
    confirmParams.icon = 'info';
    this.confirm(confirmParams);
    ;
  }

  sweetImageMessage(confirmParams: IConfirm) {
    const msg = new AppAlert(
      confirmParams.message!,
      AppAlertType.sweetImageMessage
    );
    msg.header = confirmParams.header;
    msg.acceptLabel = confirmParams.acceptLabel;
    msg.image = confirmParams.image;
    msg.accept = confirmParams.accept;

    this._eventSource.next(msg);
  }

  sweetInput(confirmParams: IConfirm) {
    const msg = new AppAlert(confirmParams.message!, AppAlertType.sweetInput);
    msg.header = confirmParams.header;
    msg.acceptLabel = confirmParams.acceptLabel;
    msg.accept = confirmParams.accept;

    this._eventSource.next(msg);
  }

  sweetAutoClose(header: string, message: string, time?: number) {
    const event = new AppAlert(message, AppAlertType.sweetAutoClose);
    event.header = header;
    event.time = time;
    this._eventSource.next(event);
  }

  confirm(confirmParams: IConfirm) {
    /*'warning' | 'error' | 'success' | 'info' */
     const warningHtml = confirmParams.warningInfo
    ? `
      <div class="swal-warning-info">
        <span class="swal-warning-icon">!</span>
        <span>${this.escapeHtml(confirmParams.warningInfo)}</span>
      </div>
    `
    : '';
      const messageHtml = confirmParams.html
    ? confirmParams.html
    : confirmParams.message
      ? `<div class="swal-main-message">${this.escapeHtml(confirmParams.message)}</div>`
      : '';
    let body:any={}
    if(confirmParams.message){
      body['text']=confirmParams.message
     }else if(confirmParams.html){
       body['html']=confirmParams.html
     }
     Swal.fire({
       ...body,
      html: `${messageHtml}${warningHtml}`,
       title: confirmParams.header,
       icon: confirmParams.icon || 'warning',
       showCancelButton:confirmParams.showCancelButton,
       showCloseButton: confirmParams.showCloseButton ?? false,
       confirmButtonColor:"#59d08b",
       cancelButtonColor:"#ff7676",
       confirmButtonText: confirmParams.acceptLabel || this.translate.instant('general.boolean.yes'),
       cancelButtonText: confirmParams.rejectLabel || this.translate.instant('general.boolean.no'),
       reverseButtons: true,
       allowOutsideClick: false,
       customClass: {
         confirmButton: 'swal-button',
         cancelButton: 'swal-button'
       }

     }).then(res => {
       if (res.isConfirmed) {
         this.acceptFunction = confirmParams.accept || (() => {
         });
         this.acceptFunction();
       } else if (res.isDenied) {
         this.rejectFunction = confirmParams.reject || (() => {
         });
         this.rejectFunction();
       } else if (res.isDismissed) {
         this.rejectFunction = confirmParams.reject ?? (() => {
         });
         this.rejectFunction();
       }
     })

  }

  private escapeHtml(value: string): string {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  close() {
    Swal.close();
  }
}
